import api from "./api";

export async function getPlaintes(page = 1, filters = {}) {
    const params = { page, ...filters };
    const res = await api.get("/admin/complaints", { params });
    return res.data.data; 
}

export async function getPlainte(id) {
    const res = await api.get(`/admin/complaints/${id}`);
    return res.data.data;
}

export async function changePlainteStatus(id, id_status) {
    const res = await api.patch(`/admin/complaints/${id}/status`, { id_status });
    return res.data.data;
}